class CodeToVal {
    constructor () {
        this.keysVal = {
            ZERO: 0,
            ONE: 1,
            TWO: 2,
            THREE: 3,
            FOUR: 4,
            FIVE: 5,
            SIX: 6,
            SEVEN: 7,
            EIGHT: 8,
            NINE: 9,
        };
    }


    getKeyValue (code) {
        return this.keysVal[code];
    }
}

export default CodeToVal;



// WEBPACK FOOTER //
// ./src/utils/CodeToVal.js